export enum OrderStatus {
  CREATED = "created",
  WAITING_FOR_PAYMENT = "waiting_for_payment",
  PROCESSING = "processing",
  PRINTING = "printing",
  READY = "ready",
  ISSUED = "issued",
  COMPLETED = "completed",
  CANCELED = "canceled",
  ERROR = "error"
}

export enum ColorType {
  BLACK_WHITE = "bw",
  COLORED = "color"
}

export type PageFormatType = "A4" | "3x4" | "10x10" | "10x15" | "11x11" | "11x20";
